module.exports = __webpack_public_path__ + "img/share_blog.94764db8.svg";